import React from 'react';
import { Helmet } from 'react-helmet';
import InternalWallInsulationPage from '@/components/internal-wall-insulation/InternalWallInsulationPage';
import Layout from '@/components/Layout';

const InternalWallInsulation = () => {
  return (
    <>
      <Helmet>
        <title>EPC Builder</title>
        <meta name="description" content="Cavity Wall Insulation" />
      </Helmet>
      <Layout title="EPC Builder Cavity Wall Insulation">
        <InternalWallInsulationPage />
      </Layout>
    </>
  );
};

export default InternalWallInsulation;
